import { Network, isDevnet, isTestnet } from '@injectivelabs/networks'
import type { NetworkType } from '../../../types/network'

const NETWORK: Network =
  (import.meta.env.VITE_NETWORK as Network) || Network.Devnet
const IS_DEVNET = isDevnet(NETWORK)
const IS_TESTNET = isTestnet(NETWORK)

export const IS_PRODUCTION: boolean = process.env.NODE_ENV === 'production'
export const IS_DEVELOPMENT: boolean = process.env.NODE_ENV === 'development'

const VITE_ENV = import.meta.env.VITE_ENV as string
const VITE_NETWORK = import.meta.env.VITE_NETWORK as string

export const MAINTENANCE_ENABLED: boolean =
  import.meta.env.VITE_MAINTENANCE_ENABLED === 'true'

const MAINNET_CHAIN_ID = 'injective-1'
const TESTNET_CHAIN_ID = 'injective-888'
const DEVNET_CHAIN_ID = 'injective-777'

export const NETWORK_CHAIN_ID_DISPLAY: Record<string, any> = {
  [Network.Local]: DEVNET_CHAIN_ID,
  [Network.Devnet]: DEVNET_CHAIN_ID,
  [Network.Devnet1]: DEVNET_CHAIN_ID,
  [Network.Devnet2]: DEVNET_CHAIN_ID,
  [Network.Mainnet]: MAINNET_CHAIN_ID,
  [Network.Staging]: MAINNET_CHAIN_ID,
  [Network.Testnet]: TESTNET_CHAIN_ID,
  [Network.MainnetLB]: MAINNET_CHAIN_ID,
  [Network.MainnetK8s]: MAINNET_CHAIN_ID,
  [Network.MainnetOld]: MAINNET_CHAIN_ID,
  [Network.TestnetK8s]: TESTNET_CHAIN_ID,
  [Network.TestnetOld]: TESTNET_CHAIN_ID,
  [Network.TestnetSentry]: TESTNET_CHAIN_ID
}

export const NETWORK_BASE_URL: Record<string, any> = {
  [Network.Mainnet]: 'https://injscan.com',
  [Network.Staging]: 'https://injscan.com',
  [Network.MainnetLB]: 'https://injscan.com',
  [Network.MainnetK8s]: 'https://injscan.com',
  [Network.MainnetOld]: 'https://injscan.com',
  [Network.Local]: 'https://devnet.explorer.injective.dev/',
  [Network.Devnet]: 'https://devnet.explorer.injective.dev/',
  [Network.Devnet1]: 'https://devnet-1.explorer.injective.dev/',
  [Network.Devnet2]: 'https://devnet-2.explorer.injective.dev/',
  [Network.Testnet]: 'https://testnet.explorer.injective.network/',
  [Network.TestnetK8s]: 'https://testnet.explorer.injective.network/',
  [Network.TestnetOld]: 'https://testnet.explorer.injective.network/',
  [Network.TestnetSentry]: 'https://testnet.explorer.injective.network/'
}

const NETWORK_DISPLAY: Record<string, any> = {
  [Network.Local]: Network.Devnet,
  [Network.Devnet]: Network.Devnet,
  [Network.Devnet1]: Network.Devnet,
  [Network.Mainnet]: Network.Mainnet,
  [Network.Staging]: Network.Mainnet,
  [Network.Testnet]: Network.Testnet,
  [Network.MainnetK8s]: Network.Mainnet,
  [Network.MainnetOld]: Network.Mainnet,
  [Network.TestnetK8s]: Network.Testnet,
  [Network.TestnetOld]: Network.Testnet,
  [Network.MainnetSentry]: Network.Mainnet,
  [Network.TestnetSentry]: Network.Testnet
}

export const MAINNET: NetworkType = {
  display: Network.Mainnet,
  network: Network.Mainnet,
  baseUrl: NETWORK_BASE_URL[Network.Mainnet]
}

export const DEVNET: NetworkType = {
  display: Network.Devnet,
  network: Network.Devnet,
  baseUrl: NETWORK_BASE_URL[Network.Devnet]
}

export const TESTNET: NetworkType = {
  display: Network.Testnet,
  network: Network.Testnet,
  baseUrl: NETWORK_BASE_URL[Network.Testnet]
}

const defaultNetwork = VITE_ENV
  ? IS_DEVNET
    ? DEVNET.network
    : IS_TESTNET
      ? TESTNET.network
      : MAINNET.network
  : NETWORK_DISPLAY[VITE_NETWORK]

const defaultDisplay = VITE_ENV
  ? IS_DEVNET
    ? DEVNET.display
    : IS_TESTNET
      ? TESTNET.display
      : MAINNET.display
  : NETWORK_DISPLAY[VITE_NETWORK]

const defaultBaseUrl = VITE_ENV
  ? IS_DEVNET
    ? DEVNET.baseUrl
    : IS_TESTNET
      ? TESTNET.baseUrl
      : MAINNET.baseUrl
  : NETWORK_BASE_URL[VITE_NETWORK]

export const DEFAULT_NETWORK: NetworkType = {
  display: defaultDisplay,
  baseUrl: defaultBaseUrl,
  network: Object.values(Network).includes(NETWORK) ? NETWORK : defaultNetwork
} as NetworkType

export const NETWORKS: NetworkType[] = IS_DEVNET
  ? [MAINNET, DEVNET, TESTNET]
  : [MAINNET, TESTNET]

export const FEE_PAYER_PUB_KEY =
  !IS_DEVNET && !IS_TESTNET
    ? (import.meta.env.VITE_FEE_PAYER_PUB_KEY as string)
    : ''
